import { WebClient } from "../utilities/WebClient";
import { AppConfig } from "../AppConfig";

export class AuthService {
    static async AuthCheck() {
        let endpoint = AppConfig.ApiServer + "/auth/authcheck";
        return WebClient.Get<{loggedId: boolean}>(endpoint)
    }
}